import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
// } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import logger from 'redux-logger';

import dataSlice from './data/data.slice';
import optionsSlice from './options/options.slice';
import uiSlice from './ui/ui.slice';
import mapSlice from './map/map.slice';
import episodesSlice from './episodes/episodes.slice';
import alternateDataSlice from './alternate-data/alternate-data.slice';

const reducer = combineReducers({
  data: dataSlice,
  options: optionsSlice,
  ui: uiSlice,
  map: mapSlice,
  episodes: episodesSlice,
  alternateData: alternateDataSlice,
});

export const store = configureStore({
  reducer: reducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production',
});

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['options'],
// };

// const persistedReducer = persistReducer(persistConfig, reducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }).concat(logger),
//   devTools: process.env.NODE_ENV !== 'production',
// });

// export const persistor = persistStore(store);
